import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgChatBubbles = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M18.4225 7.62249C18.0633 6.62084 17.4973 5.70599 16.7614 4.93743C16.0254 4.16887 15.1359 3.5638 14.1507 3.16157C13.1656 2.75934 12.1068 2.56895 11.0432 2.60277C9.97963 2.6366 8.93508 2.89388 7.97747 3.3579C7.01985 3.82192 6.17061 4.48228 5.48497 5.29605C4.79932 6.10982 4.29261 7.05879 3.99779 8.08124C3.70297 9.1037 3.62663 10.1768 3.77374 11.2307C3.92086 12.2845 4.28812 13.2957 4.85167 14.1983L2.625 18.875L7.30167 16.6483C8.16269 17.1849 9.12284 17.5428 10.125 17.7008"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.625 7.625H13.875"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.625 11.375H10.125"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.9016 10.75C17.7611 10.746 18.6033 10.9909 19.3267 11.455C20.0501 11.9191 20.6238 12.5826 20.9784 13.3654C21.3331 14.1483 21.4537 15.0171 21.3256 15.8669C21.1976 16.7168 20.8263 17.5114 20.2566 18.155L20.8158 21.375L17.8991 19.5767C17.2856 19.7175 16.6493 19.7272 16.0317 19.6051C15.4142 19.4829 14.8294 19.2318 14.3157 18.868C13.802 18.5042 13.3709 18.036 13.0507 17.4941C12.7304 16.9521 12.5282 16.3487 12.4574 15.7232C12.3865 15.0977 12.4486 14.4643 12.6394 13.8645C12.8303 13.2646 13.1458 12.7119 13.5651 12.2424C13.9844 11.7729 14.4982 11.3972 15.0727 11.1401C15.6473 10.8829 16.2696 10.75 16.8991 10.75H16.9016Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.25 13.875H15.75"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.25 16.375H15.75"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgChatBubbles.displayName = 'SvgChatBubbles';
export default SvgChatBubbles;
